import SubscriptionStateApi from '../../../api/SubscriptionStateApi';
import { SUBSCRIPTION_STATES } from '../../../constants/subscription-state';
import featureFlag from '../../../api/featureFlag';
import SavingsChallengeCommunityPopup from '../../../pages/responsive-pages/authenticated/challenges/SavingsChallengeCommunityPopup.vue';
import SavingsChallengeIndividualPopup from '../../../pages/responsive-pages/authenticated/challenges/SavingsChallengeIndividualPopup.vue';

const LOCAL_STORAGE_KEY = 'riseup.savingsChallenge';

const state = {
  eligbleForChallenge: false,
  variant: null,
};

const getters = {
  shouldShowChallenge: state => {
    const popupShown = localStorage.getItem(LOCAL_STORAGE_KEY);
    return !popupShown && state.eligbleForChallenge;
  },
  variantComponent: state => (state.variant === 'community' ? SavingsChallengeCommunityPopup : SavingsChallengeIndividualPopup),
};

const actions = {
  async initSavingsChallenge({ commit }) {
    const { state } = await SubscriptionStateApi.fetchSubscriptionState();
    const savingsChallengeVariant = await featureFlag.getTreatment('savings-challenge');
    if (['community', 'individual'].includes(savingsChallengeVariant) &&
      [SUBSCRIPTION_STATES.TRIAL, SUBSCRIPTION_STATES.FREE, SUBSCRIPTION_STATES.SUBSCRIBED].includes(state)) {
      commit('setEligibleForChallenge', true);
      commit('setVariant', savingsChallengeVariant);
    }
  },
  setPopupClosed() {
    localStorage.setItem(LOCAL_STORAGE_KEY, true);
  },
};

// mutations
const mutations = {
  setEligibleForChallenge(state, isEligible) {
    state.eligbleForChallenge = isEligible;  // eslint-disable-line
  },
  setVariant(state, variant) {
    state.variant = variant;  // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/challenges/savingsChallenge.js